import supabase from "../supabase";

export const logApiCall = async (ticketId, orderIds, comprobanteNro, request, response, memo = null, observations = null) => {
  const logData = {
    ticketId,
    orderIds,
    comprobante_nro: comprobanteNro,
    request,
    response,
    memo,
    observations,
  };

  try {
    // Intentar insertar en la base de datos
    const { data, error } = await supabase
      .from("logs")
      .insert([logData])
      .select();

    if (error) {
      console.error("Error logging API call to database:", error);
      // No fallar si la base de datos no está disponible
      return null;
    }

    return data;
  } catch (error) {
    console.error("Error in logApiCall:", error);
    // No lanzar error para evitar interrumpir el flujo principal
    return null;
  }
};

export const logError = async (error, context, ticketId = null, orderIds = null, comprobanteNro = null) => {
  const logData = {
    ticketId,
    orderIds,
    comprobante_nro: comprobanteNro,
    request: null,
    response: null,
    memo: {
      error: error.message,
      stack: error.stack,
      context: context,
      timestamp: new Date().toISOString(),
    },
    observations: `Error en ${context}: ${error.message}`,
  };

  try {
    // Intentar insertar en la base de datos
    const { data, error: logError } = await supabase
      .from("logs")
      .insert([logData])
      .select();

    if (logError) {
      console.error("Error logging error to database:", logError);
      // No fallar si la base de datos no está disponible
      return null;
    }

    return data;
  } catch (logError) {
    console.error("Error in logError:", logError);
    // No lanzar error para evitar interrumpir el flujo principal
    return null;
  }
}; 